<div class="content">
  <form [formGroup]="form">
    <glxy-form-field [required]="true">
      <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_NOTE.NOTE_TITLE' | translate }}</glxy-label>
      <input matInput [formControl]="form.controls.title" [required]="true" id="note-title" />
      <automata-automation-variable-menu
        matSuffix
        useGalaxyCompat="true"
        dontIncludeDefaultCategories="true"
        (variableSelected)="insertVariable('note-title', form.controls.title, $event)"
      ></automata-automation-variable-menu>
    </glxy-form-field>
    <glxy-form-field [required]="true">
      <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_NOTE.NOTE_BODY' | translate }}</glxy-label>
      <textarea
        id="note-body"
        matInput
        [formControl]="form.controls.body"
        cdkTextareaAutosize
        cdkAutosizeMinRows="4"
        cdkAutosizeMaxRows="8"
        [required]="true"
      ></textarea>
      <automata-automation-variable-menu
        matSuffix
        useGalaxyCompat="true"
        dontIncludeDefaultCategories="true"
        (variableSelected)="insertVariable('note-body', form.controls.body, $event)"
      ></automata-automation-variable-menu>
    </glxy-form-field>
    <automata-automation-replacement-chips
      [label]="'COMMON.TAGS' | translate"
      [dataService]="tagsService"
      [formControl]="form.controls.tags"
      [isRequired]="false"
      [multiple]="true"
      [supportDataPassing]="false"
      (finishedInitialLoading)="finishedLoadingSelector()"
      [extraData]="{ fieldId: activityTags, objectType: 'Activity' }"
      [allowCustomValues]="true"
    ></automata-automation-replacement-chips>
  </form>
</div>
